import React, { useEffect, useState } from 'react';
import { useToken } from '../App';
import { API_ENDPOINTS } from '../config/api';
import './GuestHeader.css'; // Optionally create for header-specific styles

const GuestHeader: React.FC = () => {
  const { hotelId, roomId } = useToken()!;
  const [hotelName, setHotelName] = useState('');
  const [guestName, setGuestName] = useState('');
  const [roomNumber, setRoomNumber] = useState('');

  useEffect(() => {
    if (hotelId) {
      fetch(API_ENDPOINTS.HOTELS(hotelId))
        .then(res => res.json())
        .then(data => {
          setHotelName(data.hotel_name || '');
        })
        .catch(() => setHotelName(''));
    }
    if (hotelId && roomId) {
      fetch(API_ENDPOINTS.ROOM_GUEST(hotelId, roomId))
        .then(res => res.json())
        .then(data => {
          setGuestName(data.guest_name || '');
          setRoomNumber(data.room_number || roomId);
        })
        .catch(() => {
          setGuestName('');
          setRoomNumber(roomId);
        });
    }
  }, [hotelId, roomId]);

  return (
    <div className="header" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2000 }}>
      <div className="container">
        <div className="hotel-logo">{hotelName || 'Hotel'}</div>
        <div className="room-info">
          {guestName ? `Welcome, ${guestName}` : 'Welcome'}
          {roomNumber ? ` | Room ${roomNumber}` : ''}
        </div>
      </div>
    </div>
  );
};

export default GuestHeader; 